module.exports = __webpack_public_path__ + "static/media/asian-arowana.90b11757.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/asian-arowana.png
// module id = 293
// module chunks = 0